import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from "rxjs";
import { EntityModel } from 'src/app/models/legalentity-model';
import { InfraService } from './infra.service';

@Injectable()
export class LegalEntityService {
 private configUrl: string;
 private coreAPIUrl: string;

  constructor(private infraService: InfraService, private http: HttpClient) {

    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint1 + 'legalEntity';
      this.coreAPIUrl = data.WebEndPoint2 + 'LegalEntity';
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }
  }

  public getEntities(engagementId : number): Observable<EntityModel[]> {
    return this.http.get<EntityModel[]>(`${this.coreAPIUrl}/GetEngagementEntities/${engagementId}`);
    // .catch(this.handleError);
  }

  private handleError(error: Response) {
    return throwError(()=> error);
  }
}
